import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import NadaConsta from "../../../components/nadaConsta";
import { formatarParaMoedaBRL } from "../../../utils";
import { Card } from "primereact/card";

export default function PendenciaFinanceira({
  pendenciaFinanceira,
  isConsultaNova,
}: {
  pendenciaFinanceira: any;
  isConsultaNova?: boolean;
}) {
  const { t } = useTranslation();

  const ocorrencias = pendenciaFinanceira?.PEND_FINANCEIRAS?.OCORRENCIAS ?? [];
  const hasOcorrencias = ocorrencias.length > 0;

  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string }) => any }) => {
    return value.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const getResumo = () => {
    const resumos: any[] = [];
    if (!hasOcorrencias) return resumos;

    let valorTotal = 0.0;
    let quantidade = 0;
    let data: Date | null = null;

    ocorrencias.forEach((ocorrencia: any) => {
      quantidade++;
      valorTotal += Number(ocorrencia.VALOR.replace('R$ ', '').replaceAll('.', '').replace(',', '.'));
      const [dia, mes, ano] = ocorrencia.DATA_INCLUSAO.split(/[\/: ]/).map((v: string) => parseInt(v));
      const dataFormatada = new Date(ano, mes - 1, dia);
      if (data == null || data < dataFormatada) data = dataFormatada;
    });

    return [
      { icon: 'pi pi-chart-line', label: 'Quantidade Registros', value: quantidade },
      { icon: 'pi pi-calendar-clock', label: 'Última ocorrência', value: data ? formatDate(data as any) : 'Não Informada' },
      { icon: 'pi pi-dollar', label: 'Valor Total', value: formatarParaMoedaBRL(valorTotal) },
    ];
  };

  const formatarValor = (item: any) => formatarParaMoedaBRL(Number(item.VALOR.replace(',', '.')));

  if (isConsultaNova) {
    const resumos = getResumo();
    return (
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 20px -2px rgba(0,0,0,0.05)',
          padding: '24px',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div
            style={{
              backgroundColor: hasOcorrencias ? '#FEF2F2' : '#F0FDF4',
              borderRadius: '10px',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i
              className={hasOcorrencias ? 'pi pi-exclamation-triangle' : 'pi pi-check-circle'}
              style={{ color: hasOcorrencias ? '#DC2626' : '#16A34A', fontSize: '18px' }}
            />
          </div>
          <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: 0, color: '#1E3A8A' }}>
            {t('restricaoMercado')}
          </h3>
          {hasOcorrencias && (
            <span
              style={{
                marginLeft: 'auto',
                backgroundColor: '#FEE2E2',
                color: '#9B1C1C',
                fontSize: '0.75rem',
                fontWeight: 700,
                padding: '3px 10px',
                borderRadius: '20px',
              }}
            >
              {ocorrencias.length} pendência{ocorrencias.length !== 1 ? 's' : ''}
            </span>
          )}
        </div>

        {!hasOcorrencias ? (
          <NadaConsta />
        ) : (
          <>
            {/* Summary cards */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                gap: '12px',
                marginBottom: '20px',
              }}
            >
              {resumos.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    backgroundColor: '#1E3A8A',
                    borderRadius: '12px',
                    padding: '14px 16px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    <span style={{ color: '#93C5FD', fontSize: '0.7rem', fontWeight: 700, textTransform: 'uppercase' }}>
                      {item.label}
                    </span>
                    <span style={{ color: '#FFFFFF', fontWeight: 800, fontSize: '1rem' }}>{item.value}</span>
                  </div>
                  <span
                    style={{
                      backgroundColor: 'rgba(255,255,255,0.15)',
                      borderRadius: '50%',
                      width: '32px',
                      height: '32px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <i className={item.icon} style={{ color: '#FFFFFF', fontSize: '14px' }} />
                  </span>
                </div>
              ))}
            </div>

            {/* Pendências Financeiras section header */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '12px',
                padding: '8px 0',
                borderBottom: '1px solid #E5E7EB',
              }}
            >
              <i className="pi pi-exclamation-triangle" style={{ color: '#DC2626', fontSize: '14px' }} />
              <span style={{ fontWeight: 700, color: '#DC2626', fontSize: 'small' }}>Pendências Financeiras</span>
            </div>

            {/* Table */}
            <div style={{ overflowX: 'auto', borderRadius: '10px', border: '1px solid #F3F4F6' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: 'small' }}>
                <thead>
                  <tr style={{ backgroundColor: '#F9FAFB', borderBottom: '2px solid #E5E7EB' }}>
                    {[t('dataRegistro'), t('dataVencimento'), t('credor'), t('contrato'), t('natureza'), t('tipo'), t('valor')].map(h => (
                      <th
                        key={h}
                        style={{
                          padding: '10px 14px',
                          fontWeight: 700,
                          color: '#6B7280',
                          fontSize: '0.7rem',
                          textTransform: 'uppercase',
                          letterSpacing: '0.04em',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {ocorrencias.map((o: any, idx: number) => (
                    <tr
                      key={idx}
                      style={{ borderBottom: idx < ocorrencias.length - 1 ? '1px solid #F3F4F6' : 'none' }}
                      onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#FEF2F2')}
                      onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}
                    >
                      <td style={{ padding: '10px 14px', color: '#374151', whiteSpace: 'nowrap' }}>{o.DATA_INCLUSAO}</td>
                      <td style={{ padding: '10px 14px', color: '#374151', whiteSpace: 'nowrap' }}>{o.DATA_VENCIMENTO}</td>
                      <td style={{ padding: '10px 14px', fontWeight: 600, color: '#1F2937' }}>{o.CREDOR}</td>
                      <td style={{ padding: '10px 14px', color: '#374151' }}>{o.CONTRATO}</td>
                      <td style={{ padding: '10px 14px' }}>
                        <span style={{ backgroundColor: '#F3F4F6', color: '#374151', fontSize: '0.7rem', fontWeight: 700, padding: '2px 8px', borderRadius: '4px' }}>
                          {o.MODALIDADE}
                        </span>
                      </td>
                      <td style={{ padding: '10px 14px' }}>
                        <span style={{ backgroundColor: '#FEE2E2', color: '#9B1C1C', fontSize: '0.7rem', fontWeight: 700, padding: '2px 8px', borderRadius: '4px' }}>
                          {o.TIPO_DEVEDOR}
                        </span>
                      </td>
                      <td style={{ padding: '10px 14px', fontWeight: 700, color: '#DC2626', whiteSpace: 'nowrap' }}>{o.VALOR}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    );
  }

  // Legacy layout
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return (
      <div className={className}>
        {hasOcorrencias ? (
          <span style={{ color: '#C70039', fontSize: '1.5rem' }} className="pi pi-exclamation-triangle">
            <span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>
              {t('restricaoMercado')}
            </span>
          </span>
        ) : (
          <span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>
            {t('restricaoMercado')}
          </span>
        )}
      </div>
    );
  };

  return (
    <Panel headerTemplate={headerTemplate}>
      {!hasOcorrencias ? (
        <NadaConsta />
      ) : (
        <>
          <div className="flex-consulta flex-wrap gap-3">
            {getResumo().map((item: any, index: number) => (
              <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
                <div className="flex-consulta justify-content-between gap-5">
                  <div className="flex-consulta flex-column gap-1">
                    <span style={{ color: 'white' }} className="text-sm">{item.label}</span>
                    <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
                  </div>
                  <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                    <i className={item.icon} />
                  </span>
                </div>
              </Card>
            ))}
          </div>
          <br></br>
          <DataTable size="small" value={ocorrencias} tableStyle={{ minWidth: '50rem' }}>
            <Column field="DATA_INCLUSAO" header={t('dataRegistro')}></Column>
            <Column field="DATA_VENCIMENTO" header={t('dataVencimento')}></Column>
            <Column field="MODALIDADE" header={t('natureza')}></Column>
            <Column field="CONTRATO" header={t('contrato')}></Column>
            <Column field="CREDOR" header={t('credor')}></Column>
            <Column field="TIPO_DEVEDOR" header={t('tipo')}></Column>
            <Column field="VALOR" header={t('valor')}></Column>
          </DataTable>
        </>
      )}
    </Panel>
  );
}
